export default 'iwave-connect';
